export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Plana transitable',
        name_es: 'Plana transitable',
        name_en: 'Flat and transitable'
    }, {
        id: 3,
        name_ca: 'Plana no transitable',
        name_es: 'Plana no transitable',
        name_en: 'Flat, not transitable'
    }, {
        id: 4,
        name_ca: 'Inclinada de pissarra',
        name_es: 'Inclinada de pizarra',
        name_en: 'Pitched, slate'
    }, {
        id: 4,
        name_ca: 'Inclinada de zinc',
        name_es: 'Inclinada de zinc',
        name_en: 'Pitched, zinc'
    }, {
        id: 5,
        name_ca: 'Inclinada de teula',
        name_es: 'Inclinada de teja',
        name_en: 'Pitched, tile'
    }, {
        id: 6,
        name_ca: 'Part plana, part teula',
        name_es: 'Parte plana, parte teja',
        name_en: 'partially flat, partially pitched, with tile'
    }, {
        id: 7,
        name_ca: 'Panell sandvitx',
        name_es: 'Panel Sándwich',
        name_en: 'Sandwich panel'
    }, {
        id: 8,
        name_ca: 'Enjardinada',
        name_es: 'Ajardinada',
        name_en: 'Gardened'
    }
]





// WEBPACK FOOTER //
// ./src/options/roofs.js